import colorpickercontrast from "../../../../assets/videos/colorpickercontrast.mp4";
import colorpickerfromelement from "../../../../assets/images/docs/colorpickerfromelement.mp4";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  colorpickercontrast,
  colorpickerfromelement,
  ShortCutDisplay,
  React
};